import { Helmet } from 'react-helmet-async'
import { Outlet } from 'react-router-dom'
import clsx from 'clsx'
import { useAuthModal } from 'contexts/auth-modal-context'
import { AuthModal } from 'components/organisms/modals/auth-modal'
import { usePageTracking } from 'hooks/use-page-tracking'

export function OfferPublicLayout() {
	usePageTracking()
	const { isAuthModalOpen, closeAuthModal, initialEmail, initialForm, redirectTo, onSuccessCallback } = useAuthModal()

	return (
		<div>
			<Helmet
				bodyAttributes={{
					class: clsx('bg-theme-surface'),
				}}
			/>
			<div className="min-h-screen mx-auto">
				<main className="pb-20">
					{/* Start main area*/}
					<Outlet />
					{/* End main area */}
				</main>
			</div>
			<AuthModal
				open={isAuthModalOpen}
				setOpen={closeAuthModal}
				initialEmail={initialEmail}
				initialForm={initialForm}
				redirectTo={redirectTo}
				onSuccess={onSuccessCallback}
			/>
		</div>
	)
}
